import { ActionUserInfo } from '@/app/models/projects-service'
import { formatDate, formatDateLocale } from '@/app/utils/commonFunctions'
import { BareHtml } from '../Messaging/Message/BareHtml'
import './CancelledReasons.scss'

const CancelledReasons = (props: { actionUserInfo: ActionUserInfo }) => {
    const { actionUserInfo } = props

    const componentClass = 'smart-modals-visit-execution-cancelled-reasons'

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__message text`}>
                {actionUserInfo.macroreason}
            </div>
            <div className={`${componentClass}__message text`}>
                {actionUserInfo.reason}
            </div>
            <div className={`${componentClass}__details`}>
                <div className={`${componentClass}__details__date`}>
                    {formatDateLocale(formatDate(actionUserInfo.date))}
                </div>
                <div className={`${componentClass}__details__user`}>
                    {`${actionUserInfo.role} - ${actionUserInfo.nickname ? actionUserInfo.nickname : actionUserInfo.name}${actionUserInfo.nickname ? '' : (' ' + actionUserInfo.lastname)}`}
                </div>
            </div>
        </div>
    )
}

export default CancelledReasons
